import React from 'react';
import BooleanFilter from './booleanFilter.jsx';
import GridDateFilter from './dateFilter.jsx';
import DropDownFilter from './dropdownFilter.jsx';
import GridNumberFilter from './numberFilter.jsx';
import GridStringFilter from './stringFilter.jsx';

export default class GridFilter extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            column: this.props.column,
            value: this.props.value
        };

		this.filterControl = null;
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            column: newProps.column,
            value: newProps.value
        });
    }

	reloadOptions() {
		if (this.filterControl && this.filterControl.reloadOptions) {
			this.filterControl.reloadOptions();
		}
	}

    render() {
        if (this.state.column.filterType === 'number') {
            return (
                <GridNumberFilter column={this.state.column}
                    value={this.state.value}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
					ref={control => this.filterControl = control}
                />
            );
        } else if (this.state.column.filterType === 'date') {
            return (
                <GridDateFilter column={this.state.column}
                    value={this.state.value}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
					ref={control => this.filterControl = control}
                />
            );
        } else if (this.state.column.filterType === 'dropdown') {
            return (
                <DropDownFilter column={this.state.column}
                    value={this.state.value}
                    onChange={this.props.onChange}
                    loadUrl={this.props.loadUrl}
                    gridSettings={this.props.gridSettings}
                    disabled={this.props.disabled}
                    columnWidth={this.props.columnWidth}
					ref={control => this.filterControl = control}
                />
            );
        } else if (this.state.column.filterType === 'boolean') {
            return (
                <BooleanFilter column={this.state.column}
                    value={this.state.value}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
					ref={control => this.filterControl = control}
                />
            );
        } else if (this.state.column.filterType === 'string') {
            return (
                <GridStringFilter column={this.state.column}
                    value={this.state.value}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
					ref={control => this.filterControl = control}
                />
            );
        } else {
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./App/grid/filter/filter.jsx